import Vue from "vue";
import { TestState } from "@/model/Model";
import { EventCategory, UserInteractionEvent } from "@/model/UserEvents";
import Urls from "./Urls";
export const UpdatedHeight = () => {
    Vue.nextTick(() => {
        // Send the new dom height to the parent embedding the iframe.
        const app = document.getElementById("app");
        // console.log('request height change', app.offsetHeight);
        window.parent.postMessage({
            type: "height-changed",
            height: app.offsetHeight
        }, "*");
    });
};
export const ScrollToTop = (offset = 0) => {
    Vue.nextTick(() => {
        if (window.parent !== window) {
            // Send the new dom height to the parent embedding the iframe.
            window.parent.postMessage({
                type: "scroll-to-top",
                offset
            }, "*");
        }
        else {
            window.scrollTo({ top: offset, behavior: "smooth" });
        }
    });
};
export const removeWidows = (input, maxWidows = 2) => {
    // Take the last `maxWidows` words and insert non-breaking spaces between them, so they don't get widowed.
    if (input === undefined) {
        return "";
    }
    const pieces = input.split(" ");
    const endItems = Math.min(pieces.length, maxWidows);
    const first = pieces.length - endItems;
    const left = pieces.slice(0, first);
    const right = pieces.slice(first);
    return `${left.join(" ")} ${right.join("&nbsp;")}`;
};
export const interpolateString = (input, replaceMap) => {
    let inputStr = typeof input === "string" ? input : input();
    if (replaceMap) {
        for (const key in replaceMap) {
            if (replaceMap.hasOwnProperty(key)) {
                const regex = new RegExp("\\${" + key + "}", "gi");
                const replaceVal = replaceMap[key]();
                const val = (replaceVal && replaceVal.label) || "";
                inputStr = inputStr.replace(regex, val);
            }
        }
    }
    return inputStr;
};
const getCategoryForEvent = (eventName) => {
    switch (eventName) {
        case UserInteractionEvent.PlanCreated:
        case UserInteractionEvent.DrinkCoach:
        case UserInteractionEvent.PostCodeEntered:
        case UserInteractionEvent.DirectedToHub:
        case UserInteractionEvent.ClickedEnfieldLocalAdvice:
        case UserInteractionEvent.ClickedOnlineAppointment:
            return `${EventCategory[EventCategory.FollowUpAction]}`;
        case UserInteractionEvent.SelectAge:
        case UserInteractionEvent.SelectEthnicity:
        case UserInteractionEvent.SelectGender:
        case UserInteractionEvent.SelectSubRegion:
        case UserInteractionEvent.SelectSexuality:
        case UserInteractionEvent.SelectOrgType:
        case UserInteractionEvent.SelectStaffGroup:
            return `${EventCategory[EventCategory.Demographics]}`;
        case UserInteractionEvent.StartQuiz:
            return `${EventCategory[EventCategory.GoalConversion]}`;
        case UserInteractionEvent.WhereHeardAboutDBIU:
            return `${EventCategory[EventCategory.ReferralPath]}`;
        case UserInteractionEvent.CompletedQuiz:
            return `${EventCategory[EventCategory.AUDIT]}`;
        case UserInteractionEvent.RiskLevel:
            return `${EventCategory[EventCategory.AuditResults]}`;
        default:
            return `${UserInteractionEvent[eventName]}`;
    }
};
export const LogEvent = (eventName, value) => {
    if (eventName === UserInteractionEvent.LaunchUrl) {
        // If it's a special url, we may want to change the event.
        if (value && value.toString().startsWith(Urls.Appointment)) {
            eventName = UserInteractionEvent.ClickedOnlineAppointment;
        }
        else if (value === Urls.Pdf) {
            eventName = UserInteractionEvent.ClickedEnfieldLocalAdvice;
        }
        else if (value === Urls.AppStore || value === Urls.PlayStore) {
            eventName = UserInteractionEvent.DrinkCoach;
        }
    }
    const eventCategory = getCategoryForEvent(eventName);
    const region = TestState.region().name;
    let eventNameString = `${UserInteractionEvent[eventName]}`;
    if (eventName === UserInteractionEvent.SelectSubRegion) {
        eventNameString = `${region.replace(/ /g, "")}Borough`;
    }
    const event = {
        type: "user-event",
        eventCategory,
        eventName: null,
        region,
        value
    };
    if (eventCategory !== eventNameString) {
        event.eventName = eventNameString;
    }
    else {
        event.eventName = value;
    }
    if (window.parent === window) {
        console.log(event);
    }
    window.parent.postMessage(event, "*");
};
//# sourceMappingURL=utils.js.map